define.alias("shared/components/shared/social-identity", "media/components/shared/social-identity");